module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.sets), function(lottery) {
    return _c('draw-from-sets', {
      key: lottery.name,
      attrs: {
        "lottery": lottery
      }
    })
  }), _vm._v(" "), _vm._l((_vm.sequences), function(lottery) {
    return _c('sequence', {
      key: lottery.name,
      attrs: {
        "lottery": lottery
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f17e2942"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Start.vue
// module id = 82
// module chunks = 1